import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import './index.scss'
class OzTestimol extends Component {

  render() {
    const {} = this.props
    return (
      <section className="oz-testimol">
        <div className="oz-testimol__mask-dark"></div>
        <div className="oz-testimol__mask-light"></div>
        {/*<div className="oz-testimol__content">*/}
        {/*  <h1 className="oz-testimol__content__title">“Never accept the proposition that just because a solution satisfies a problem, that it must be the only solution”</h1>*/}
        {/*  <h1 className="oz-testimol__content__subtitle">- Raymond E. Feist</h1>*/}
        {/*</div>*/}

        <div className="row oz-testimol__footer">
          <div className="oz-testimol__footer__left">
            <h1>We Believe in</h1>
          </div>
          <div className="oz-testimol__footer__right">
            <p>Challenging existing business models by pursuing newer and more effective ways to solve today&#39;s problems. Our online management system modernizes the way you organize and retrieve information, making the process fast, simple, and cost effective.</p>
          </div>
        </div>
      </section>
    )
  }
}

export default withRouter(OzTestimol)
